<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="姓名："
        prop="name">
        <el-input v-model="info.name"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号："
        prop="mobilePhone">
        <el-input v-model="info.mobilePhone"></el-input>
      </el-form-item>
      <el-form-item
        label="微信手机号："
        prop="wxMobilePhone">
        <el-input v-model="info.wxMobilePhone"></el-input>
      </el-form-item>
      <el-form-item
        label="固定电话："
        prop="phone">
        <el-input v-model="info.phone"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱："
        prop="email">
        <el-input v-model="info.email"></el-input>
      </el-form-item>
      <el-form-item
        label="部门："
        prop="department">
        <el-input v-model="info.department"></el-input>
      </el-form-item>
      <el-form-item
        label="职位："
        prop="position">
        <el-input v-model="info.position"></el-input>
      </el-form-item>
      <el-form-item
        label="职位2："
        prop="position2">
        <el-input v-model="info.position2"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditPackageModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        nameCardId: null,
        name: '',
        mobilePhone: '',
        wxMobilePhone: '',
        email: '',
        department: '',
        position: '',
        phone: '',
        position2: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 15, message: '姓长度最多 15 个字符', trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        phone: [
          // { required: true, message: '请输入固定电话', trigger: 'blur' },
          {
            pattern: /^[0][0-9]{2,3}-[0-9]{5,10}$/,
            message: '请输入正确的固定电话',
            trigger: 'blur'
          }
        ],
        wxMobilePhone: [
          { required: true, message: '请输入微信手机号', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'blur' },
          { max: 15, message: '职位长度最多 15 个字符', trigger: 'blur' }
        ],
        position2: [
          { required: false, message: '请输入职位2', trigger: 'blur' },
          { max: 15, message: '职位长度最多 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const nameCardId = this.info.nameCardId
      return (nameCardId ? '编辑' : '新增') + '电子名片'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        nameCardId: null,
        name: '',
        mobilePhone: '',
        wxMobilePhone: '',
        phone: '',
        email: '',
        position: '',
        position2: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.nameCardId
            ? 'updatenamecard'
            : 'addnamecard'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
